import { Trans, useTranslation } from 'react-i18next';
import { Landmark } from '@parrot-software/design-system/icons';

import { PaymentMethodCard } from './PaymentMethodCard';

/** Stable RadioGroup value identifying the SPEI payment method. */
export const SPEI_PAYMENT_METHOD_VALUE = 'SPEI';

const strongComponents = { strong: <strong className="font-semibold" /> };

type SpeiPaymentMethodCardProps = {
  disabled?: boolean;
  isSelected: boolean;
};

/**
 * SPEI payment-method card.
 *
 * Owns the icon and copy for the SPEI option and renders them through the
 * generic `PaymentMethodCard` wrapper. Bold spans inside the body and bullet
 * come from `<strong>` tags in the i18n strings (single key per text block).
 * Renders disabled when the block is already configured with SPEI.
 *
 * @param props - Component properties
 * @returns React element rendering the SPEI card
 */
export const SpeiPaymentMethodCard = ({ disabled = false, isSelected }: SpeiPaymentMethodCardProps) => {
  const { t } = useTranslation('subscriptions');

  return (
    <PaymentMethodCard
      disabled={disabled}
      icon={<Landmark aria-hidden className="h-6 w-6 text-foreground" />}
      isSelected={isSelected}
      title={t('paymentMethod.spei')}
      value={SPEI_PAYMENT_METHOD_VALUE}
    >
      <p className="whitespace-pre-line text-sm font-normal leading-5 text-muted-foreground">
        <Trans components={strongComponents} i18nKey="subscriptions:blockCreationWizard.payment.spei.body" />
      </p>
      <ul className="ml-4 list-disc text-xs leading-3 text-muted-foreground">
        <li>
          <Trans components={strongComponents} i18nKey="subscriptions:blockCreationWizard.payment.spei.bullet" />
        </li>
      </ul>
    </PaymentMethodCard>
  );
};
